import {
  purchaseOrderTypes,
  getListTypes,
  getByIdTypes,
  deliveryVoucherTypes,
  invoiceFileTypes,
  associatedInvoiceTypes,
  requestPaymentTypes,
  requestAutomatedPaymentTypes,
  sortPurchaseOrders
} from './types';

const purchaseOrderActions = {
  getPurchaseOrdersRequest: (payload: string) => ({
    type: getListTypes.REQUEST,
    payload
  }),
  getPurchaseOrdersSuccess: (payload: any) => ({
    type: getListTypes.SUCCESS,
    payload
  }),
  getPurchaseOrdersFailed: payload => ({
    type: getListTypes.FAILED,
    payload
  }),

  getPurchaseOrderByIdRequest: (payload: string) => ({
    type: getByIdTypes.REQUEST,
    payload
  }),
  getPurchaseOrderByIdSuccess: (payload: any) => ({
    type: getByIdTypes.SUCCESS,
    payload
  }),
  getPurchaseOrderByIdFailed: payload => ({
    type: getByIdTypes.FAILED,
    payload
  }),

  getAssociatedInvoicesRequest: (payload: string) => ({
    type: associatedInvoiceTypes.GET_REQUEST,
    payload
  }),
  getAssociatedInvoicesSuccess: (payload: any) => ({
    type: associatedInvoiceTypes.GET_SUCCESS,
    payload
  }),
  getAssociatedInvoicesFailed: payload => ({
    type: associatedInvoiceTypes.GET_FAILED,
    payload
  }),

  getAssociatedInvoicesInfoRequest: (payload: string) => ({
    type: associatedInvoiceTypes.GET_INFO_REQUEST,
    payload
  }),
  getAssociatedInvoicesInfoSuccess: (payload: any) => ({
    type: associatedInvoiceTypes.GET_INFO_SUCCESS,
    payload
  }),
  getAssociatedInvoicesInfoFailed: payload => ({
    type: associatedInvoiceTypes.GET_INFO_FAILED,
    payload
  }),

  requestPaymentRequest: payload => ({
    type: requestPaymentTypes.REQUEST,
    payload
  }),
  requestPaymentSuccess: payload => ({
    type: requestPaymentTypes.SUCCESS,
    payload
  }),
  requestPaymentFailed: payload => ({
    type: requestPaymentTypes.FAILED,
    payload
  }),

  requestAutomatedPaymentRequest: payload => ({
    type: requestAutomatedPaymentTypes.REQUEST,
    payload
  }),
  requestAutomatedPaymentSuccess: payload => ({
    type: requestAutomatedPaymentTypes.SUCCESS,
    payload
  }),
  requestAutomatedPaymentFailed: payload => ({
    type: requestAutomatedPaymentTypes.FAILED,
    payload
  }),

  setSelectedOrder: payload => ({
    type: purchaseOrderTypes.SET_SELECTED_ORDER,
    payload
  }),

  getDeliveryVouchersRequest: payload => ({
    type: deliveryVoucherTypes.GET_REQUEST,
    payload
  }),
  getDeliveryVouchersSuccess: payload => ({
    type: deliveryVoucherTypes.GET_SUCCESS,
    payload
  }),
  getDeliveryVouchersFailed: payload => ({
    type: deliveryVoucherTypes.GET_FAILED,
    payload
  }),

  addDeliveryVoucherRequest: payload => ({
    type: deliveryVoucherTypes.ADD_REQUEST,
    payload
  }),
  addDeliveryVoucherSuccess: payload => ({
    type: deliveryVoucherTypes.ADD_SUCCESS,
    payload
  }),
  addDeliveryVoucherFailed: payload => ({
    type: deliveryVoucherTypes.ADD_FAILED,
    payload
  }),

  deleteDeliveryVoucherRequest: payload => ({
    type: deliveryVoucherTypes.DELETE_REQUEST,
    payload
  }),
  deleteDeliveryVoucherSuccess: payload => ({
    type: deliveryVoucherTypes.DELETE_SUCCESS,
    payload
  }),
  deleteDeliveryVoucherFailed: payload => ({
    type: deliveryVoucherTypes.DELETE_FAILED,
    payload
  }),

  getInvoiceFilesRequest: payload => ({
    type: invoiceFileTypes.GET_REQUEST,
    payload
  }),
  getInvoiceFilesSuccess: payload => ({
    type: invoiceFileTypes.GET_SUCCESS,
    payload
  }),
  getInvoiceFilesFailed: payload => ({
    type: invoiceFileTypes.GET_FAILED,
    payload
  }),

  addInvoiceFileRequest: payload => ({
    type: invoiceFileTypes.ADD_REQUEST,
    payload
  }),
  addInvoiceFileSuccess: payload => ({
    type: invoiceFileTypes.ADD_SUCCESS,
    payload
  }),
  addInvoiceFileFailed: payload => ({
    type: invoiceFileTypes.ADD_FAILED,
    payload
  }),

  deleteInvoiceFileRequest: payload => ({
    type: invoiceFileTypes.DELETE_REQUEST,
    payload
  }),
  deleteInvoiceFileSuccess: payload => ({
    type: invoiceFileTypes.DELETE_SUCCESS,
    payload
  }),
  deleteInvoiceFileFailed: payload => ({
    type: invoiceFileTypes.DELETE_FAILED,
    payload
  }),

  associateManualInvoiceRequest: payload => ({
    type: associatedInvoiceTypes.ADD_REQUEST,
    payload
  }),
  associateManualInvoiceSuccess: payload => ({
    type: associatedInvoiceTypes.ADD_SUCCESS,
    payload
  }),
  associateManualInvoiceFailed: payload => ({
    type: associatedInvoiceTypes.ADD_FAILED,
    payload
  }),

  deleteAssociatedInvoiceRequest: payload => ({
    type: associatedInvoiceTypes.DELETE_REQUEST,
    payload
  }),
  deleteAssociatedInvoiceSuccess: payload => ({
    type: associatedInvoiceTypes.DELETE_SUCCESS,
    payload
  }),
  deleteAssociatedInvoiceFailed: payload => ({
    type: associatedInvoiceTypes.DELETE_FAILED,
    payload
  }),

  associateElectronicInvoicesRequest: payload => ({
    type: associatedInvoiceTypes.ADD_E_REQUEST,
    payload
  }),
  associateElectronicInvoicesSuccess: payload => ({
    type: associatedInvoiceTypes.ADD_E_SUCCESS,
    payload
  }),
  associateElectronicInvoicesFailed: payload => ({
    type: associatedInvoiceTypes.ADD_E_FAILED,
    payload
  }),

  changeInvoicesStateRequest: payload => ({
    type: requestPaymentTypes.CHANGE_STATE_REQUEST,
    payload
  }),
  changeInvoicesStateSuccess: payload => ({
    type: requestPaymentTypes.CHANGE_STATE_SUCCESS,
    payload
  }),
  changeInvoicesStateFailed: payload => ({
    type: requestPaymentTypes.CHANGE_STATE_FAILED,
    payload
  }),
  changeInvoicesStateSomeInvoicesAreFailed: payload => ({
    type: requestPaymentTypes.CHANGE_STATE_SOME_INOVICES_ARE_FAILED,
    payload
  }),
  sortPurchaseOrders: payload => ({
    type: sortPurchaseOrders.SORT,
    payload
  }),
  closeFeedBackModal: () => ({
    type: requestPaymentTypes.CLOSE_FEEDBACK_MODAL
  }),
  deletePurchaseOrderRequest: (payload: string) => ({
    type: purchaseOrderTypes.DELETE_REQUEST,
    payload
  }),
  deletePurchaseOrderSuccess: (payload: string) => ({
    type: purchaseOrderTypes.DELETE_SUCCESS,
    payload
  }),
  deletePurchaseOrderFailed: payload => ({
    type: purchaseOrderTypes.DELETE_FAILED,
    payload
  }),

  restorePurchaseOrderRequest: (payload: string) => ({
    type: purchaseOrderTypes.RESTORE_REQUEST,
    payload
  }),
  restorePurchaseOrderSuccess: (payload: string) => ({
    type: purchaseOrderTypes.RESTORE_SUCCESS,
    payload
  }),
  restorePurchaseOrderFailed: payload => ({
    type: purchaseOrderTypes.RESTORE_FAILED,
    payload
  }),
  
  addPurchaseOrdersRequest: payload => ({
    type: purchaseOrderTypes.ADD_REQUEST,
    payload
  }),
  addPurchaseOrdersSuccess: payload => ({
    type: purchaseOrderTypes.ADD_SUCCESS,
    payload
  }),
  addPurchaseOrdersFailed: payload => ({
    type: purchaseOrderTypes.ADD_FAILED,
    payload
  })
};

export default purchaseOrderActions;
